import { Reveal, Overline } from "./Reveal";
import { Trees, GraduationCap, Landmark, Flower2, Sparkles, BookOpen } from "lucide-react";

const ICONS = [Trees, GraduationCap, Landmark, Flower2, Sparkles, BookOpen];
// Tetris-style spans for visual tension (cycles for 6 items)
const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-4", "md:col-span-4", "md:col-span-4", "md:col-span-12"];

export const Landmarks = ({ t }) => (
  <section id="landmarks" data-testid="landmarks-section" className="py-24 md:py-36 bg-copou-surface">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal className="max-w-2xl mb-14">
        <Overline>{t.landmarks.overline}</Overline>
        <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-4 text-copou-ink">{t.landmarks.title}</h2>
      </Reveal>

      <div className="grid md:grid-cols-12 gap-6">
        {t.landmarks.items.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={i} delay={i * 0.08} className={SPANS[i]}>
              <div
                data-testid={`landmark-card-${i}`}
                className="group h-full bg-copou-bg border border-copou-line p-8 md:p-10 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-12 h-12 flex items-center justify-center border border-copou-primary text-copou-primary mb-6 group-hover:bg-copou-primary group-hover:text-white transition-colors">
                  <Icon size={22} strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-2xl text-copou-ink mb-3">{item.t}</h3>
                <p className="text-copou-muted leading-relaxed">{item.d}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
